// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';

import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PaginationDetailsStyled = styled.div({
	flex: 1,
	textAlign: 'right',
	margin: `${token('space.100', '8px')} ${token('space.200', '16px')}`,
	font: token('font.body'),
	color: token('color.text.subtlest', '#979797'),
});
